import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';

import { TTgbStretchContext } from 'shared/components/adfox/bannerTemplateTypes';
import { IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';

import { type TTgbStretchProps } from '../TgbStretch';

type TGetTgbNativedescGeneralWidePropsParams = {
  context: TTgbStretchContext;
  sizes: TAdFoxBannerCompleteSizes;
  bannerEnrichment: null | IBannerEnrichments;
};

export function getTgbStretchProps({
  context: {
    url,
    label,
    title,
    description,
    note,
    logoImageUrl,
    button,
    bgImageUrl,
    mortgageTermsWarning,
    mortgageWarning,
  },
  sizes,
  bannerEnrichment,
}: TGetTgbNativedescGeneralWidePropsParams): TTgbStretchProps {
  const props: TTgbStretchProps = {
    logoUrl: logoImageUrl,
    url,
    label,
    button,
    image: bgImageUrl,
    annotation: note,
    title,
    description,
    mortgageTermsWarning,
    mortgageWarning,
    sizes,
  };

  if (bannerEnrichment) {
    Object.assign<TTgbStretchProps, Partial<TTgbStretchProps>>(props, {
      logoUrl: bannerEnrichment.publisher.logo.url,
    });
  }

  return props;
}
